import { MaintenancePanel } from '../../components/MaintenancePanel';
import { SupportBundlePanel } from '../../components/SupportBundlePanel';
import { UpgradeReadinessPanel } from '../../components/UpgradeReadinessPanel';

/** Operations section: maintenance mode, upgrade readiness, and support-bundle export. */
export function PlatformSettings(): JSX.Element {
  return (
    <>
      <MaintenancePanel />
      <UpgradeReadinessPanel />
      <SupportBundlePanel />
    </>
  );
}
